<template>
	<li
		v-if="checkItemLicense"
		class="item-aside"
		:class="base_class"
		@click="$emit('click')"
	>
		<span v-if="type == 'header'">{{ title }}</span>

		<router-link :to="link" v-if="type == 'sigle' && link != undefined">
			<i v-if="icon != undefined" class="fa" :class="'fa-' + icon"></i>
			<span>{{ title }}</span>
			<span v-if="labels != undefined" class="pull-right-container">
				<small
					v-for="(label, index) in labels"
					:key="index"
					:title="label.title"
					class="label pull-right"
					:class="'bg-' + label.color"
					>{{ label.text }}
				</small>
			</span>
		</router-link>

		<a v-if="type == 'tree'" @click="open('item')">
			<i v-if="icon != undefined" class="fa" :class="'fa-' + icon"></i>
			<span>{{ title }}</span>
			<span v-if="labels != undefined" class="pull-right-container">
				<small
					v-for="(label, index) in labels"
					:key="index"
					:title="label.title"
					class="label pull-right"
					:class="'bg-' + label.color"
					>{{ label.text }}
				</small>
			</span>
			<span v-else class="pull-right-container">
				<i
					class="fa fa-angle-left pull-right"
					:style="'transform: rotate(' + arrow_rotate + ')'"
				></i>
			</span>
		</a>
		<!--  -->
		<ul
			class="treeview-menu"
			v-if="type == 'tree' && childs != undefined"
			:style="{ height: (!openAll ? my_height : '') + 'px' }"
		>
			<li
				v-for="(child, index) in fChilds"
				:key="index"
				:class="child.link == $route.path ? 'active' : ''"
			>
				<router-link :to="child.link">
					<i class="fa fa-circle-o"></i>{{ child.text }}
				</router-link>
			</li>
		</ul>
	</li>
</template>
<script>
	import { mapState } from 'vuex';

	export default {
		name: 'ItemAside',
		props: [
			'title',
			'icon',
			'link',
			'childs',
			'labels',
			'hash',
			'openAll',
			'opened',
		],
		data() {
			return {
				arrow_rotate: 0,
				my_height: 0,
			};
		},
		methods: {
			open(op) {
				if (this.title == this.opened) {
					this.$emit('clkme', '');
				} else {
					this.$emit('clkme', this.title);
				}
			},
			check(perm) {
				if (perm == undefined) return true;
				let index = this.licenses.findIndex((item) => {
					if (perm.indexOf(item) != -1) return item;
				});
				return index != -1 ? true : false;
			},
		},
		watch: {
			opened: function (val) {
				if (this.childs != undefined) {
					if (this.my_height == 0 && this.title == val) {
						this.my_height = 30 * this.fChilds.length;
						this.arrow_rotate = '-90deg';
					} else {
						this.arrow_rotate = '0deg';
						this.my_height = 0;
					}
				} else {
				}
			},
		},
		computed: {
			...mapState({
				licenses: (s) => s.user_data.perfil.licenses,
			}),
			is_title() {
				return this.title == undefined ? false : true;
			},
			is_icon() {
				return this.icon == undefined ? false : true;
			},
			is_link() {
				return this.link == undefined ? false : true;
			},
			is_childs() {
				return this.childs == undefined ? false : true;
			},
			is_labels() {
				return this.labels == undefined ? false : true;
			},

			checkItemLicense() {
				if (this.hash != undefined) return this.check(this.hash);
				if (this.childs != undefined) {
					let count = this.childs.reduce((acc, item) => {
						if (this.check(item.hash)) acc++;
						return acc;
					}, 0);
					return count > 0;
				}
				return true;
			},

			fChilds() {
				return this.childs.filter((item) => this.check(item.hash));
			},

			actice_class() {
				if (this.link != undefined && this.$route.path == this.link)
					return 'active';
				if (this.childs != undefined) {
					let GetChild = [];
					if (
						typeof this.childs == 'object' &&
						Array.isArray(this.childs)
					)
						GetChild = this.childs;
					else GetChild = this.childs() || [];

					let sub = GetChild.findIndex(
						(item) => item.link == this.$route.path
					);
					if (sub == -1) return '';
					else return 'active';
					// console.log( GetChild );
				} else return '';
			},

			base_class() {
				if (this.type == 'header') return 'header ' + this.actice_class;
				else if (this.type == 'sigle') return this.actice_class;
				else return 'treeview ' + this.actice_class;
			},

			type() {
				if (
					this.is_title &&
					!this.is_icon &&
					!this.is_link &&
					!this.is_childs &&
					!this.is_labels
				) {
					return 'header';
				} else if (this.is_title && this.is_link && !this.is_childs) {
					return 'sigle';
				} else if (this.is_title && this.is_childs) {
					return 'tree';
				}
			},
		},
		mounted() {},
	};
</script>
<style scoped>
	.treeview-menu {
		display: block !important;
		overflow: hidden !important;
		-webkit-transition: height linear 0.4s !important;
		-o-transition: height linear 0.4s !important;
		transition: height linear 0.4s !important;
	}
	.item-aside {
		cursor: pointer !important;
	}
	.fa.fa-angle-left.pull-right {
		-webkit-transition: all linear 0.4s !important;
		-o-transition: all linear 0.4s !important;
		transition: all linear 0.4s !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/cnt-app/components/item.aside.vue